import { useState } from "react";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Header from "layouts/profile/components/Header";
import InfoTab from "layouts/profile/components/InfoTab";
import AccountsTab from "layouts/profile/components/AccountsTab";
import WalletsTab from "layouts/profile/components/WalletsTab";

function Profile() {
  const [tabValue, setTabValue] = useState(0);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Header tabValue={tabValue} setTabValue={setTabValue}>
        <MDBox mt={5} mb={3}>
          {tabValue === 0 && <InfoTab />}
          {tabValue === 1 && <WalletsTab />}
          {tabValue === 2 && <AccountsTab />}
        </MDBox>
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default Profile;
